/* eslint-disable camelcase */
import styled from '@emotion/styled'
import type { FC, PropsWithChildren } from 'react'

import Button from '@segment/matcha/components/Button'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import * as CopyText from '@segment/matcha/recipes/CopyText'
import SignupButton from '@segment/matcha/recipes/SignupButton'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Sign up for a free trial today, or chat with a member of our team to find out what a CDP can deliver for your business.`,
  button: {
    text: `Create a free account`,
  },
  demoButton: {
    text: `Get a demo`,
    href: `/demo/?utm_source=ebook&utm_medium=referral&utm_campaign=all_cnt_2023-10-17-cnt-growth-report_20231017&utm_content=ebook`,
  },
}

const Signup: FC<PropsWithChildren<unknown>> = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper>
      <StyledSectionBase variant="noCopy">
        <Section.Contents>
          <CopyText.Heading variant="h4">{copy.heading}</CopyText.Heading>
          <Buttons>
            <Button
              size="large"
              tag="a"
              href={getAbsoluteUrl(copy.demoButton.href, pageConfig)}
              variant="filled"
              color="primary"
            >
              {copy.demoButton.text}
            </Button>
            <SignupButton
              tag="a"
              variant="outlined"
              additionalParams={{
                utm_source: `ebook`,
                utm_medium: `referral`,
                utm_campaign: `all_cnt_2023-10-17-cnt-growth-report_20231017`,
                utm_content: `ebook`,
              }}
            >
              {copy.button.text}
            </SignupButton>
          </Buttons>
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div``
const Buttons = styled.div`
  display: grid;
  max-width: 520px;
  width: 100%;
  grid-template-columns: auto auto;
  grid-template-rows: auto;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    grid-template-columns: auto;
  }
`

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding: 0;
    padding-bottom: 80px;
  }
`

export default Signup
